import apiHelper from '@/helpers/apiHelper';

export default {
	find() {
		return apiHelper.appGet(`census`);
	},

	update(data) {
		return apiHelper.appPut(`census`, data);
	},

	getMarketplaceUrl() {
		return apiHelper.getAppUrl('marketplace');
	},

	getAgentMarketplaceUrlBcbsm() {
		return apiHelper.getAppUrl('marketplace/agent/bcbsm');
	},

	getAgentMarketplaceUrlPriority() {
		return apiHelper.getAppUrl('marketplace/agent/priority');
	},
};
